<template>
  <div class="about">
    <page-nav-bar @navBarClick="navBarClick"/>
    <page-main :item="mainItem"/>
  </div>
</template>

<script>
// 左侧导航栏
import pageNavBar from './pages/navBar'
// 内容区
import pageMain from './pages/main'
import { mapActions, mapGetters } from "vuex";
export default {
  name: 'about',
  data() {
    return {
      mainItem: 'pageCompany'
    }
  },
    computed:{
        ...mapGetters({
            getIsLoadIng: "pageOrgMeta/getIsLoadIng",
            getData: "pageOrgMeta/getData",
        }),
    },
    //服务端渲染
    asyncData({ store,route }) {
        let params = {
            type:13,
            zone_name:route.params.name
        }
        return store.dispatch("pageOrgMeta/setOrgMeta", [params, () => {}]);
    },
    mounted() {
        const webName = this.$route.params.name;
        if (!this.getIsLoadIng){
            let parmas = {
                type:13,
                zone_name:webName
            }
            this.setOrgMeta([parmas,()=>{
                this.filteData();
            }])
        }else{
            this.filteData();
        }
    },
    methods: {
      ...mapActions({
          setOrgMeta:"pageOrgMeta/setOrgMeta"
      }),
      filteData(){
          let data = this.$store.state["pageOrgMeta"]["data"]
          console.log(data,'pageOrgMeta')
          document.title = data.meta ? data.meta.title :'';
          let head = document.getElementsByTagName('head');
          this.isLoading = false
          if(!document.querySelector('meta[name=description]')){
              let meta = document.createElement('meta');
              meta.name = 'description';
              meta.content = data.meta ? data.meta.description : '';
              head[0].appendChild(meta)
          }else{
              document.querySelector('meta[name=description]').setAttribute('content',data.meta ? data.meta.description : '')
          }
      },
    navBarClick(item) {
      if(this.mainItem === item) return
      this.mainItem = item
    }
  },
  components: {
    pageNavBar,
    pageMain
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
